<template>
  <div class="w-100">
    <div class="d-flex justify-content-between">
      <button class="fw-bold p-2 mb-2 btn bg-white shadow-sm bg-body rounded" data-bs-toggle="modal"
        data-bs-target="#filterModal">
        Filter Setting
        <font-awesome-icon icon="fa fa-gear" class="mx-2" />
      </button>
    </div>
    <div class="alert alert-info" role="alert" v-show="alertMessage">
      {{alertMessage}}
    </div>
    <ModalConfirm 
      modalId="categoryModal" 
      :text="`Your change(s) will affect other Menu(s) that has dependency to Category Promo. Please make sure other related Category Promo Menu has been checked and reviewed.`" 
      @onClick="deleteCategory(id)"
      :center="true" :buttonConfig="{
          cancelText: 'CANCEL',
          confirmText: `CONFIRM`
        }" />
    <div class="modal fade" id="filterModal" tabindex="-1" aria-labelledby="filterModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title fsize-16" id="filterModalLabel">Filter Setting</p>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <label class="col-sm-3 col-form-label fw-bold">
                Category Promo Showed
              </label>
              <div class="col-md-8 ms-3">
                <v-select label="name" multiple v-model="selected" :options="listPromo" />
              </div>
            </div>
          </div>
          <div class="m-3 d-flex justify-content-start">
            <button type="button" class="btn btn-secondary bg-white border border-danger text-danger rounded me-3"
              data-bs-dismiss="modal">Cancel</button>
            <button 
              type="button" 
              class="btn btn-danger text-white shadow-sm rounded" 
              @click="setFilter"
              data-bs-dismiss="modal"
              >
                Save Setting
              </button>
          </div>
        </div>
      </div>
    </div>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:date="{ data }">
        <div>
          {{data.created_date}} <br/> by {{data.created_by_name}}
        </div>
      </template>
      <template v-slot:name="{ value, data }">
        <div>
          <router-link
            :to="'/products/category-promo/detail/'+data.id" 
            class="text-decoration-none"
            style="color: #5e50a1"
          >
            {{ value }}
          </router-link>
        </div>
      </template>
      <template v-slot:product_count="{ data, value }">
        <div>
           <router-link
            :to="'/products/category-promo/detail/'+data.id" 
            class="fw-bold text-danger text-decoration-none"
          >
            {{ value }} Products
          </router-link>
        </div>
      </template>
      <template v-slot:date_start="{ value }">
        <div>
          <p v-if="value != ''">{{value}}</p>
          <p v-else> </p>
        </div>
      </template>
      <template v-slot:date_end="{ value }">
        <div>
          <p v-if="value != ''">{{value}}</p>
          <p v-else> </p>
        </div>
      </template>
      <template v-slot:actions="{ value }">
        <div>
          <router-link
            :to="'/products/' + value.url" 
            class="btn"
            :class="value.edit == 'disable' ? 'disabled' : ''"
          >
            <img src="@/assets/ic_edit.svg" alt="edit"/>
          </router-link>
          <button class="btn" @click="setIdCategory(value.id)" data-bs-toggle="modal" data-bs-target="#categoryModal">
            <font-awesome-icon icon="fa-solid fa-ban" class="text-danger" />
          </button>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  import vSelect from "vue-select";
  import 'vue-select/dist/vue-select.css';
  import ModalConfirm from "@/components/ModalConfirm.vue";

  export default {
    components: {
      TableBasic,
      vSelect,
      ModalConfirm
    },
    data() {
      return {
        id : "",
        payload: {
          header: [{
              key: "date",
              label: "CREATED DATE",
              class: "text-justify",
              sort: true,
              sort_key: "created_date"
            },
            { 
              key: "name",
              label: "CATEGORY NAME",
              class: "text-justify",
              sort: true,
              sort_key: "name"
            },
            { 
              key: "badge_title",
              label: "BADGE TITLE",
              class: "text-justify",
              sort: true,
              sort_key: "badge_title"
            },
            {
              key: "product_count",
              label: "COUNT",
              class: "text-justify",
              sort: true,
              sort_key: "product_count"
            },
            {
              key: "date_start",
              label: "START DATE",
              class: "text-justify",
              sort: true,
              sort_key: "date_start"
            },
            {
              key: "date_end",
              label: "END DATE",
              class: "text-justify",
              sort: true,
              sort_key: "date_end"
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-justify",
            },
          ],
          value: [],
          filter: true,
          filterLabel: "Filter by Created date",
          search: true,
          searchInput: "",
          searchPlaceholder: 'Search by category, badge title',
          searchContainerStyle: {
            maxWidth: '215px'
          },
          button_name: "Add New",
          button_link: "/products/category-promo/add",
          icon_button: "add",
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100],
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },

        },
        selected: [],
        filterValue: {},
        alertMessage: "",
        listPromo: []
      };
    },
    methods: {
      changeParameter(value) {
        console.log(value)
        this.payload.perPage = value.per_page
        this.payload.currentPage = value.current_page
        this.filterValue = value.filter
        this.searchInput = value.search
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.getData()
      },
      setIdCategory(value) {
        this.id = value
      },
      async getData() {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
        }
        if (this.searchInput != "") {
          payload.keyword = this.searchInput
        }

        if (this.filterValue) {
          payload.date_start = this.filterValue.from
          payload.date_end = this.filterValue.to
        }

        if (this.sortBy != ""){
          payload.sort_by = this.payload.sortBy
          payload.sort_type = this.payload.sortType
        }

        const response = await this.$store.dispatch("product/getAllCategoryPromo", payload)
        let resdata = this.$store.getters['product/categoryPromoItems']

        this.payload.value = resdata
        this.payload.totalRows = response.count
      },
      async getCategoryFilter() {
        try {
          const response = await this.$store.dispatch("product/getAllCategoryPromoFilter")
          let activePromo = []
          response.items.forEach(item=>{
            if(item.is_active) activePromo.push(item)
          })
          this.listPromo = response.items
          this.selected = activePromo
        } catch (err) {
          console.log(err)
        }
      },
      async setFilter() {
        try {
          const payload = {
            category_promo: this.selected
          }
          await this.$store.dispatch("product/createFilterCategoryPromo", payload)
          this.alertMessage = "Success Save Setting"
          setTimeout(() => {
            this.alertMessage = ""
          }, 1500);
        } catch (err) {
          console.log(err)
        }
      },
      async deleteCategory(value) {
        console.log("VALUE : ", value)
        try {
          await this.$store.dispatch("product/deleteCategoryPromo", value)
          const successProcess = this.$store.state.product.successInput
          if (successProcess) {
            this.alertMessage = "Success Delete"
            setTimeout(() => {
              this.alertMessage = ""
              window.location.reload(true);
            }, 1500);
          }
        } catch (error) {
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      }
    },
    async mounted() {
      this.$store.dispatch("setLoadingTable", true)
      await this.getCategoryFilter()
      this.getData()
    },
  };
</script>

<style></style>